import axiosInstance from "../../../interceptor/intercetptor-inctence";

export const getEquipmentList = (formData) => {
    return axiosInstance.post(`api/master/equipment/list`, formData);
};

export const createEquipment = (formData) => {
    return axiosInstance.post(`api/master/equipment/create`, formData);
};

export const updateEquipment = (id, formData) => {
    return axiosInstance.post(`api/master/equipment/update/${id}`, formData);
};

export const viewEquipment = (id) => {
    return axiosInstance.post(`api/master/equipment/view/${id}`, {});
};

export const toggleEquipmentStatus = (id) => {
    return axiosInstance.post(`api/master/equipment/toggle-status/${id}`, {});
};

export const deleteEquipment = (id) => {
    return axiosInstance.post(`api/master/equipment/delete/${id}`, {});
};

export const masterEquipment = () => {
    return axiosInstance.post(`api/master/equipment/master`, {});
};

export const EQUIPMENT_CATEGORIES = [
    "Collection",
    "Glassware",
    "Plasticware",
    "Instrument",
    "Safety",
    "Storage",
    "Chemical",
    "Cleaning",
    "Other",
];
